import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../constants/radar';

export const HeaderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  marginLeft: '24px',
  marginRight: '24px',
  background: 'white',
  padding: '16px 24px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  gap: '24px',
  width: 'auto',
  borderRadius: '8px',
}));

export const HeaderLeft = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const BackButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  color: COLORS.SECONDARY,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500,
  transition: 'all 0.2s ease',

  '&:hover': {
    backgroundColor: COLORS.BACKGROUND,
    color: COLORS.PRIMARY,
    transform: 'translateX(-2px)',
  },

  '& svg': {
    fontSize: '16px',
  },
}));

export const Title = styled('h1')({
  color: COLORS.PRIMARY,
  fontSize: '24px',
  margin: 0,
  fontWeight: 600,
  position: 'relative',
  paddingLeft: '16px',

  '&:before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    height: '24px',
    width: '4px',
    backgroundColor: COLORS.PRIMARY,
    borderRadius: '2px',
  },
});

export const HeaderRight = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const ViewSwitchButton = styled('button')(({ theme }) => ({
  padding: '8px 16px',
  backgroundColor: 'white',
  color: COLORS.PRIMARY,
  border: `1px solid ${COLORS.PRIMARY}`,
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  transition: 'all 0.2s ease',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  whiteSpace: 'nowrap',
  
  '&:hover': {
    backgroundColor: COLORS.PRIMARY,
    color: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },

  '&:active': {
    transform: 'translateY(0)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
}));

export const ViewSwitchIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  
  '& svg': {
    transition: 'transform 0.2s ease',
  },

  [`${ViewSwitchButton}:hover &`]: {
    '& svg': {
      transform: 'scale(1.1)',
    },
  },
}); 